import HeroCarousel from "../../custom/Carousel/HeroCarousel";

import { HeroSectionProps, Theme } from "@/src/utilities";
import { THEME } from "@/src/utilities/constants/constants";
import { useRouter } from "next/navigation";
import UniversalSearch from "../../custom/UniversalSearch";
import HeroBackground from "../../layout/background/HeroBackground";

const popularSearches = [
  "AI Integration",
  "Cyber Security",
  "Cloud Migration",
  "Automation",
  "Digital Transformation",
];

// Type-safe env variable
const theme = THEME as Theme;

/**
 *
 * @param showCarousel
 * @description showCarousel is a boolean that determines whether to show the carousel or not based on the further requirements'
 * The THEME is a type-safe env variable that determines the theme of the website
 * @returns
 */
const HeroSection = ({ showCarousel }: HeroSectionProps) => {
  const router = useRouter();
  console.log(theme, 'theme');

  if (theme == "orange") {
    return (
      <HeroBackground>
        <div className={`flex flex-col justify-center items-center w-full max-w-[1920px] mx-auto ${showCarousel ? "flex-col md:flex-row" : "flex-col items-center"}`}>
          {/* Left Section */}
          <div
            className={`${showCarousel
              ? "md:w-[60%] w-full text-left px-4 md:px-6 lg:px-8"
              : "w-full text-center px-4 md:px-6 lg:px-8"
              }`}
          >
            <div className="flex flex-col justify-center items-start pt-14 w-[85%] lg:w-[75%] xl:w-[70%] max-w-4xl mx-auto">
              <h1 className="text-3xl lg:text-5xl xl:text-6xl font-medium text-ring leading-tight text-center md:text-left">
                Find the Perfect
                <span className="text-white">
                  {" "}
                  <span className="text-white font-bold">
                    Technology Solutions
                  </span>
                  <br />
                  <span className="text-ring">for Your Business</span>
                </span>

              </h1>

              <p className="text-sm md:text-base lg:text-lg text-ring max-w-2xl leading-relaxed text-center md:text-left my-6 ">
                <span>Your source for trusted Technology Solution reviews &
                  insights.</span>
                <br />
                <span className="">Empowering smarter decisions with expert analysis and the tech
                  trends.</span>
              </p>
            </div>

            {/* Search Bar + Popular Searches here */}
            <div className="flex flex-col justify-center items-center w-full md:w-[85%] lg:w-[75%] xl:w-[70%] max-w-4xl mx-auto">
              <UniversalSearch
                variant="hero"
                placeholder="Find your perfect technology solution..."
              />
              {/* Popular Searches */}
              <div className="my-4 text-center">
                <p className="text-ring text-sm mb-2">Trending:</p>
                <div className="flex flex-wrap justify-center gap-2 max-w-full pb-10">
                  {popularSearches.map((search) => (
                    <button
                      key={search}
                      onClick={() =>
                        router.push(
                          `/search?search=${encodeURIComponent(search)}`
                        )
                      }
                      className="cursor-pointer text-xs sm:text-sm text-ring hover:text-white bg-primary/10 hover:bg-primary px-3 py-1 rounded-full transition-colors"
                    >
                      {search}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {/* Right Section (Carousel) */}
          {showCarousel && (
            <div className="md:w-[40%] w-full flex justify-center p-0 md:px-4 relative mt-4 md:mt-0">
              <HeroCarousel />
            </div>
          )}
        </div>
      </HeroBackground>
    );
  }
  if (theme == "white") {
    return (
      <section className="relative overflow-hidden">
        <div
          className={`flex w-full ${showCarousel ? "flex-col md:flex-row" : "flex-col items-center"
            }`}
        >
          {/* Left Section */}
          <HeroBackground
            className={`${showCarousel
              ? "md:w-[60%] w-full text-left"
              : "w-full text-center"
              }`}
          >
            <div className="flex flex-col justify-center items-center pt-14 w-full md:w-[50%] lg:w-[60%] mx-auto">
              <h1 className="text-2xl md:text-6xl font-medium text-theme-secondary leading-tight text-center md:text-left">
                Find the Perfect
                <span className="text-white">
                  {" "}
                  <p className="text-primary font-bold">Technology Solutions</p>
                  <span className="text-theme-secondary">for Your </span>
                </span>
                Business
              </h1>

              <p className="text-md md:text-md text-muted-foreground max-w-2xl leading-relaxed text-center md:text-left my-6">
                Your Source for Trusted Technology Solution Reviews & Insights.
                Empowering smarter decisions with expert analysis and the tech
                trends
              </p>
            </div>

            {/* Search Bar + Popular Searches here */}
            <div className="flex flex-col justify-center items-center w-full md:w-[50%] lg:w-[60%] mx-auto">
              <UniversalSearch
                variant="hero"
                placeholder="Find your perfect technology solution..."
              />
              {/* Popular Searches */}
              <div className="my-4 text-center">
                <p className="text-muted-foreground text-sm mb-2">Trending:</p>
                <div className="flex flex-wrap justify-center gap-2 max-w-full pb-10">
                  {popularSearches.map((search) => (
                    <button
                      key={search}
                      onClick={() =>
                        router.push(
                          `/search?search=${encodeURIComponent(search)}`
                        )
                      }
                      className="cursor-pointer text-sm text-muted-foreground hover:text-white bg-primary/10 hover:bg-primary px-3 py-1 rounded-full transition-colors"
                    >
                      {search}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </HeroBackground>

          {/* Right Section (Carousel) */}
          {showCarousel && (
            <div className="md:w-[40%] w-full flex items-center justify-center px-4 relative mt-6 md:mt-0">
              <HeroCarousel />
            </div>
          )}
        </div>
      </section>
    );
  }
  return null;
};

export default HeroSection;
